import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { IFilterItems, IFilterItemsItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';

type IFilterItemsItemWithValue = Exclude<IFilterItemsItem, { header: string }>;

const getOptionValue = (option: IFilterItemsItemWithValue): string | number => {
  if (typeof option === 'string') {
    return option;
  }

  return 'value' in option ? option.value : option.text;
};

export const getSelectFormattedValue = (
  value: Nullable<string | string[] | number | number[]>,
  options: IFilterItems
): string => {
  let formattedValue: string = '';

  const optionsWithValues = options.filter((option) => {
    if (typeof option === 'string') { // option string - it's a value
      return true;
    }

    return 'value' in option || 'text' in option; // remove { header: string }
  }) as IFilterItemsItemWithValue[];

  const filteredOptions = optionsWithValues.filter((option) => {
    const itemValue: string | number = getOptionValue(option);

    return Array.isArray(value) ? (value as Array<string | number>).includes(itemValue) : value === itemValue;
  });

  if (filteredOptions.length > 0) {
    formattedValue = filteredOptions.map((option) => {
      const itemValue: string | number = getOptionValue(option);
      const itemText: string = typeof option === 'string' ? option : option.text;

      return isValuePresent(itemValue) ? itemText : '';
    }).join(', ');
  }

  return formattedValue;
};
